import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import set from 'lodash/set';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { random } from './number';
import { isObjectEqual, areObjectsMatchingAtLeastOneField } from './object';

export var pickRandomInArray = function pickRandomInArray(array) {
  if (!Array.isArray(array) || !array || !array.length) {
    return null;
  }
  return array[random(0, array.length)];
};

/* find element in array, deep compare whole object for just fields passed in params */
export var getObjectIndexInArray = function getObjectIndexInArray(array, elementA, pickFields) {
  if (!array) {
    return -1;
  }
  for (var i = 0, l = array.length; i < l; ++i) {
    var elementB = array[i];
    if (isObjectEqual(elementA, elementB, pickFields)) {
      return i;
    }
  }
  return -1;
};

/* find element in array, deep compare whole object for just fields passed in params */
export var getObjectIndexInArrayMatchingAtLeastOneField = function getObjectIndexInArrayMatchingAtLeastOneField(array, elementA, pickFields) {
  if (!array || !elementA) {
    return -1;
  }
  for (var i = 0, l = array.length; i < l; ++i) {
    var elementB = array[i];
    if (areObjectsMatchingAtLeastOneField(elementA, elementB, pickFields)) {
      return i;
    }
  }
  return -1;
};

/* example : getObjectIndexInArrayByPath(array, 'item.id', 'id') */
export var getObjectIndexInArrayByPath = function getObjectIndexInArrayByPath(array, path, value) {
  if (!array || !Array.isArray(array)) {
    throw new Error('First argument should be an array');
  }
  if (!path) {
    throw new Error('Second argument should be a string');
  }
  for (var i = 0, l = array.length; i < l; ++i) {
    var obj = array[i];
    if (get(obj, path) === value) {
      return i;
    }
  }

  return -1;
};

/* return a new array and a new object at index with the a new value */
export var setValueInArrayAtIndexByPath = function setValueInArrayAtIndexByPath(array, index, path, value) {
  if (!array || !Array.isArray(array)) {
    throw new Error('First argument should be an array');
  }
  if (!path) {
    throw new Error('Third argument should be a string');
  }
  if (index < 0 || index > array.length) {
    throw new Error('Second argument should be a valid index');
  }

  var object = cloneDeep(array[index]);
  set(object, path, value);

  var newArray = [].concat(_toConsumableArray(array.slice(0, index)), [object], _toConsumableArray(array.slice(index + 1)));

  return newArray;
};

export var generateArrayOfNumbers = function generateArrayOfNumbers(max) {
  var iteration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var startAt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var array = [];
  for (var i = startAt; i <= max; i = i + iteration) {
    array.push(i);
  }
  return array;
};
//# sourceMappingURL=array.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/utils/array.js
// module id = 251
// module chunks = 0